"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const script_1 = __importDefault(require("next/script"));
const safevalues_1 = require("safevalues");
/**
 * A GooglePayments component that initializes the Google payment integrator script.
 * Payment script url for prod: https://payments.google.com/payments/v4/js/integrator.js
 * Payment script url for dev: https://payments.sandbox.google.com/payments/v4/js/integrator.js?ss=md
 */
const GooglePayments = ({ onPaymentScriptLoad, sandbox = true, }) => {
    const handlePaymentScriptLoad = () => {
        onPaymentScriptLoad(true);
    };
    const publicPaymentUrl = sandbox
        ? (0, safevalues_1.trustedResourceUrl) `https://payments.sandbox.google.com/payments/v4/js/integrator.js?ss=md`
        : (0, safevalues_1.trustedResourceUrl) `https://payments.google.com/payments/v4/js/integrator.js`;
    return ((0, jsx_runtime_1.jsx)(script_1.default, { src: publicPaymentUrl, strategy: "lazyOnload", onReady: handlePaymentScriptLoad, "data-payments-main": true }));
};
exports.default = GooglePayments;
